<template>
  <div class="widget">
    <table>
    <template v-if="state === 'Day'">
      <tr>
        <td><button @click.prevent="prevMonth()">«</button></td>
        <td colspan="3" @click.prevent="state = 'Month'">{{monthName(oDate.m)}}</td>
        <td colspan="2">{{oDate.y}}</td>
        <td><button @click.prevent="nextMonth()">»</button></td>
      </tr>
      <tr>
        <td>Dom</td>
        <td>Seg</td>
        <td>Ter</td>
        <td>Qua</td>
        <td>Qui</td>
        <td>Sex</td>
        <td>Sáb</td>
      </tr>
      <tr v-for="week,windex in month">
        <td v-for="day in week" @click="pickDate(day.yyyymmdd, windex)" :class="day.status">{{day.d}}</td>
      </tr>
    </template>
    <template v-if="state === 'Month'">
      <tr>
        <td><button @click.prevent="oDate.y-= 1">«</button></td>
        <td colspan="2">{{oDate.y}}</td>
        <td><button @click.prevent="oDate.y+= 1">»</button></td>
      </tr>
      <tr class="month">
        <td @click.prevent="selectMonth(0)">Janeiro</td>
        <td @click.prevent="selectMonth(1)">Fevereiro</td>
        <td @click.prevent="selectMonth(2)">Março</td>
        <td @click.prevent="selectMonth(3)">Abril</td>
      </tr>
      <tr class="month">
        <td @click.prevent="selectMonth(4)">Maio</td>
        <td @click.prevent="selectMonth(5)">Junho</td>
        <td @click.prevent="selectMonth(6)">Julho</td>
        <td @click.prevent="selectMonth(7)">Agosto</td>
      </tr>
      <tr class="month">
        <td @click.prevent="selectMonth(8)">Setembro</td>
        <td @click.prevent="selectMonth(9)">Outubro</td>
        <td @click.prevent="selectMonth(10)">Novembro</td>
        <td @click.prevent="selectMonth(11)">Dezembro</td>
      </tr>
    </template>
    </table>
  </div>
</template>

<script>
import jsCalendar from './JSCalendar.js'
export default {
  name: 'calendar',
  data () {
    return {
      state: 'Day',
      nowDate: {
        d: undefined,
        m: undefined,
        y: undefined
      },
      oDate: {
        m: 9,
        y: 2017
      },
      month: []
    }
  },
  methods: {
    getDate () {
      const now = new Date()
      this.nowDate.d = now.getDate()
      this.nowDate.m = now.getMonth()
      this.nowDate.y = now.getFullYear()
      this.oDate.m = now.getMonth()
      this.oDate.y = now.getFullYear()
    },
    setMonth () {
      this.month = this.monthSixWeek(this.oDate.m, this.oDate.y)
    },
    prevMonth () {
      this.oDate.m -= 1
      if (this.oDate.m < 0) {
        this.oDate.m = 11
        this.oDate.y -= 1
      }
      this.setMonth()
    },
    nextMonth () {
      this.oDate.m += 1
      if (this.oDate.m > 11) {
        this.oDate.m = 0
        this.oDate.y += 1
      }
      this.setMonth()
    },
    selectMonth (n) {
      this.oDate.m = n
      this.setMonth()
      this.state = 'Day'
    },
    monthName (n) {
      const names = ['Janeiro', 'Fevereiro', 'Março', 'Abril', 'Maio', 'Junho', 'Julho', 'Agosto', 'Setembro', 'Outubro', 'Novembro', 'Dezembro']
      return names[n]
    },
    pickDate (date, week) {
      const w = this.month[week]
      this.$emit('pickDate', date)
      this.$emit('pickWeek', w[0].yyyymmdd, w[6].yyyymmdd, w)
    }
  },
  created: function () {
    this.monthLastDay = jsCalendar.monthLastDay
    this.monthArrDays = jsCalendar.monthArrDays
    this.monthSixWeek = jsCalendar.monthSixWeek
    this.validMonth = jsCalendar.validMonth
    this.formatMonth = jsCalendar.formatMonth
    this.getDate()
    this.setMonth(this.oDate.m, this.oDate.y)
  }
}
</script>

<style scoped>
  .widget {
    width: 300px;
    max-width: 301px;
  }
  table {
    outline: 1px solid #ccc;
    font-size: 14px;
    width: 100%;
  }
  table tr td {
    text-align: center;
    width: 48px;
    height: 36px;
    background: #fff;
  }
  table tr:first-child td{
    background: #ccc;
    font: 24px sans-serif;
  }
  table tr:not(:first-child) td:first-child {
    color: #c00;
  }
  table tr td.out {
    color: #999;
  }
  table tr:not(:first-child):not(:nth-child(2)) td:hover, table tr.month td:hover {
    background: #f1f1f1;
    cursor: pointer;
  }
  table tr:first-child td button {
    font-size: 16px;
  }
  table tr.month td {
    width: 84px;
    height: 84px;
  }
  table tr.month td:first-child {
    color: #333;
  }
  table tr:not(:first-child):not(:nth-child(2)) td.now {
    background: #9cf;
  }
  @media (max-width: 499px) {
    .widget {
      width: 100%;
    }
  }
</style>



// WEBPACK FOOTER //
// src/components/Calendar.vue